import { Services } from "appworks/services/services";
import { SoundEvent } from "appworks/services/sound/sound-events";
import { SoundService } from "appworks/services/sound/sound-service";
import { SlingoSoundEvent } from "slingo/sound/slingo-sound-events";
import { SoundNames } from "sounds-enum";
import { FowlSoundEvents } from "./fowl-sound-events";

export function FowlSoundSetup() {
    const sound = Services.get(SoundService);

    // bg ambience
    sound.registerPlay(SoundEvent.start_game, { id: SoundNames.fpm_ambience_loop, loop: true, volume: 0.7, singleton: true });
    sound.registerPlay(FowlSoundEvents.geese_flying, { id: SoundNames.fpm_bg_GeeseFlying, volume: 0.6, singleton: true });
    sound.registerPlay(FowlSoundEvents.banjo_playing, { id: SoundNames.fpm_bg_BanjoDitty, singleton: true });
    sound.registerPlay(FowlSoundEvents.tractor_driving, { id: SoundNames.fpm_bg_TractorDrive, loop: true, singleton: true });
    sound.registerStop(FowlSoundEvents.tractor_stop, { id: SoundNames.fpm_bg_TractorDrive });

    // Theme music
    sound.registerPlay(SlingoSoundEvent.play_game, { id: SoundNames.fp_theme1_loop, music: true, loop: true });
    sound.registerPlayArgs(
        SlingoSoundEvent.ladder_level_up_N,
        ["4"],
        [
            { id: SoundNames.fp_misc_yeehaa, singleton: true },
            {
                id: SoundNames.fp_theme2_loop,
                music: true,
                loop: true,
            },
        ]
    );
    sound.registerPlayArgs(
        SlingoSoundEvent.ladder_level_up_N,
        ["9"],
        [
            { id: SoundNames.fp_misc_yeehaa, singleton: true },
            {
                id: SoundNames.fp_theme3_loop,
                music: true,
                loop: true,
            },
        ]
    );
    sound.registerStop("end_base_music", [{ id: SoundNames.fp_theme1_loop }, { id: SoundNames.fp_theme2_loop }, { id: SoundNames.fp_theme3_loop }]);

    // bonus transitions
    sound.registerPlay(FowlSoundEvents.slot_transition, [{ id: SoundNames.fp_trans_to_slot }, { id: SoundNames.faf_fowlplay_ui_rise }]);
    sound.registerPlay(FowlSoundEvents.pick_transition, [{ id: SoundNames.fp_trans_to_pick }, { id: SoundNames.faf_fowlplay_ui_rise }]);
    sound.registerPlay(SoundEvent.enter_basegame, { id: SoundNames.fp_board_appears, singleton: true });
    sound.registerPlay(FowlSoundEvents.chicken_cluck, { id: SoundNames.fpm_sfx_bonus_Cluck });

    // Intro
    sound.registerPlay(SoundEvent.start_game, { id: SoundNames.fp_launch_game });
    sound.registerStop(SlingoSoundEvent.play_game, { id: SoundNames.fp_launch_game });

    // Dab
    sound.registerPlayArgs(SlingoSoundEvent.dab_N, ["1"], { id: SoundNames.fp_dab_1 });
    sound.registerPlayArgs(SlingoSoundEvent.dab_N, ["2"], { id: SoundNames.fp_dab_2 });
    sound.registerPlayArgs(SlingoSoundEvent.dab_N, ["3"], { id: SoundNames.fp_dab_3 });
    sound.registerPlayArgs(SlingoSoundEvent.dab_N, ["4"], { id: SoundNames.fp_dab_4 });
    sound.registerPlayArgs(SlingoSoundEvent.dab_N, ["5"], { id: SoundNames.fp_dab_5 });

    // Full house
    sound.registerStop(SlingoSoundEvent.full_house_animation, [
        { id: SoundNames.fp_theme1_loop },
        { id: SoundNames.fp_theme2_loop },
        { id: SoundNames.fp_theme3_loop },
    ]);
    sound.registerPlay("enter_scene_CelebrationContent_fullhouse", [
        { id: SoundNames.fpm_music_FreeSpins_Loop_HighEnergy, music: true, volume: 0.5 },
        { id: SoundNames.rp_win_fullhouse },
    ]);
    sound.registerStop("exit_scene_CelebrationContent_fullhouse", { id: SoundNames.fpm_music_FreeSpins_Loop_HighEnergy, fadeTime: 750 });

    // Slingo
    sound.registerPlayArgs(SlingoSoundEvent.slingo_N, ["1"], { id: SoundNames.fp_slingo_1 });
    sound.registerPlayArgs(SlingoSoundEvent.slingo_N, ["2"], { id: SoundNames.fp_slingo_2 });
    sound.registerPlayArgs(SlingoSoundEvent.slingo_N, ["3"], { id: SoundNames.fp_slingo_3 });
    sound.registerPlayArgs(SlingoSoundEvent.slingo_N, ["4"], { id: SoundNames.fp_slingo_4 });

    sound.registerPlayArgs(SlingoSoundEvent.slingo_animate_line_N, ["0"], { id: SoundNames.fp_reels_lightsweep_forward });
    sound.registerPlayArgs(SlingoSoundEvent.slingo_animate_line_N, ["1"], { id: SoundNames.fp_reels_lightsweep_backward });
    sound.registerPlayArgs(SlingoSoundEvent.slingo_animate_line_N, ["2"], { id: SoundNames.fp_reels_lightsweep_forward });
    sound.registerPlayArgs(SlingoSoundEvent.slingo_animate_line_N, ["3"], { id: SoundNames.fp_reels_lightsweep_backward });

    // Base game reel spin
    sound.registerPlay("base_reel_start", { id: SoundNames.fp_spin_loop, loop: true });
    sound.registerStop("base_reel_land_4", { id: SoundNames.fp_spin_loop });

    // Base game reel stop
    sound.registerPlay("base_reel_land_0", { id: SoundNames.fp_reel_stop_1 });
    sound.registerPlay("base_reel_land_1", { id: SoundNames.fp_reel_stop_2 });
    sound.registerPlay("base_reel_land_2", { id: SoundNames.fp_reel_stop_3 });
    sound.registerPlay("base_reel_land_3", { id: SoundNames.fp_reel_stop_4 });
    sound.registerPlay("base_reel_land_4", { id: SoundNames.fp_reel_stop_5 });

    // Anticipation
    sound.registerPlayArgs(SoundEvent.reel_count_N_anticipate_start, ["0"], { id: SoundNames.fp_anticipation_1 });
    sound.registerPlayArgs(SoundEvent.reel_count_N_anticipate_start, ["1"], { id: SoundNames.fp_anticipation_2 });
    sound.registerPlayArgs(SoundEvent.reel_count_N_anticipate_start, ["2"], { id: SoundNames.fp_anticipation_3 });
    sound.registerStop(SoundEvent.reel_any_anticipate_end, [
        { id: SoundNames.fp_anticipation_1 },
        { id: SoundNames.fp_anticipation_2 },
        { id: SoundNames.fp_anticipation_3 },
    ]);

    // UI
    sound.registerPlay(SoundEvent.default_button_press, { id: SoundNames.fp_spin_click });
    sound.registerPlay(SlingoSoundEvent.purchase_spin, { id: SoundNames.fp_extra_spin_click });
    sound.registerPlay(SoundEvent.stake_radio_select_higher, { id: SoundNames.fp_bet_value_increase });
    sound.registerPlay(SoundEvent.stake_radio_select_lower, { id: SoundNames.fp_bet_value_decrease });

    // Special symbols
    sound.registerPlay(SlingoSoundEvent.add_coin_from_reels, { id: SoundNames.fp_free_spin_whoosh_v2, singleton: true });
    sound.registerPlay(FowlSoundEvents.free_spin_land, { id: SoundNames.fp_free_spin_added, singleton: true });

    sound.registerPlayArgs(SoundEvent.symbol_ID_land, ["FS"], { id: SoundNames.fp_free_spin_added, singleton: true });
    sound.registerPlayArgs(SoundEvent.symbol_ID_land, ["SJ"], { id: SoundNames.fp_reel_drop_superwild_v3, singleton: true });
    sound.registerPlayArgs(SoundEvent.symbol_ID_land, ["J"], { id: SoundNames.fp_reel_drop_wild_v3, singleton: true });

    // Ladder
    sound.registerPlayArgs(SlingoSoundEvent.ladder_level_up_N, ["1"], { id: SoundNames.fp_level_up_noPrize });
    sound.registerPlayArgs(SlingoSoundEvent.ladder_level_up_N, ["2"], { id: SoundNames.fp_level_up_noPrize });
    sound.registerPlayArgs(SlingoSoundEvent.ladder_level_up_N, ["3"], { id: SoundNames.fp_level_up_noPrize });
    sound.registerPlayArgs(SlingoSoundEvent.ladder_level_up_N, ["4"], { id: SoundNames.fp_level_up_noPrize });

    sound.registerPlayArgs(SlingoSoundEvent.ladder_level_up_N, ["5"], { id: SoundNames.fp_level_up_cashPrize });
    sound.registerPlayArgs(SlingoSoundEvent.ladder_level_up_N, ["6"], { id: SoundNames.fp_level_up_cashPrize });
    sound.registerPlayArgs(SlingoSoundEvent.ladder_level_up_N, ["7"], { id: SoundNames.fp_level_up_cashPrize });
    sound.registerPlayArgs(SlingoSoundEvent.ladder_level_up_N, ["8"], { id: SoundNames.fp_level_up_cashPrize });

    sound.registerPlayArgs(SlingoSoundEvent.ladder_level_up_N, ["9"], { id: SoundNames.fp_level_up_featurePrize });
    sound.registerPlayArgs(SlingoSoundEvent.ladder_level_up_N, ["10"], { id: SoundNames.fp_level_up_featurePrize });
    sound.registerPlayArgs(SlingoSoundEvent.ladder_level_up_N, ["11"], { id: SoundNames.fp_level_up_featurePrize });

    // You could win
    sound.registerPlay(SlingoSoundEvent.attract_popup, { id: SoundNames.fp_you_could_win_text, singleton: true });

    // Win countups
    sound.registerPlay(SoundEvent.winnings_countup, { id: SoundNames.fp_Prize_countup_loop, loop: true });
    sound.registerStop(SoundEvent.winnings_countup_end, { id: SoundNames.fp_Prize_countup_loop });
    sound.registerPlay(SoundEvent.big_win_linear_countup_start, { id: SoundNames.fp_Prize_countup_loop, loop: true });
    sound.registerStop(SoundEvent.big_win_countup_end, { id: SoundNames.fp_Prize_countup_loop });
    sound.registerPlay("enter_scene_CelebrationBackground_bigwin", [{ id: SoundNames.faf_chicken_win }, { id: SoundNames.bigwin, music: true }]);
    sound.registerStop("exit_scene_CelebrationBackground_bigwin", { id: SoundNames.bigwin, fadeTime: 500 });

    // Results screen
    sound.registerPlay("results_below_staked", { id: SoundNames.rp_banjoriff_1 });
    sound.registerPlay("results_buildup", { id: SoundNames.rp_snarerollgong });
    sound.registerPlay("results_reveal", [
        { id: SoundNames.rp_ip_bigwin_edit, music: true },
        { id: SoundNames.rp_win_itemsemit },
        { id: SoundNames.rp_win_totalwin },
    ]);
    sound.registerStop("results_end", [
        { id: SoundNames.rp_ip_bigwin_edit, fadeTime: 750 },
        { id: SoundNames.rp_win_itemsemit },
        { id: SoundNames.rp_win_totalwin },
    ]);

    // Flick a fox
    sound.registerPlay("faf_music_start", { id: SoundNames.fpm_music_FreeSpins_Loop_LowEnergy, music: true, loop: true, volume: 0.6 });
    sound.registerStop("faf_music_stop", { id: SoundNames.fpm_music_FreeSpins_Loop_LowEnergy, fadeTime: 500 });
    sound.registerPlay("faf_glovepunch", { id: SoundNames.faf_boxingglove_punchfox });
    sound.registerPlay("faf_gloveshove", { id: SoundNames.faf_boxingglove_shove });
    sound.registerPlay("faf_coop_shake", { id: SoundNames.faf_coup_rattle });
    sound.registerPlay("faf_intro_footstep_1", { id: SoundNames.faf_fox_footstep_1 });
    sound.registerPlay("faf_intro_footstep_2", { id: SoundNames.faf_fox_footstep_2 });
    sound.registerPlay("faf_intro_footstep_3", { id: SoundNames.faf_fox_footstep_3 });
    sound.registerPlay("faf_intro_footstep_4", { id: SoundNames.faf_fox_footstep_4 });
    sound.registerPlay("faf_intro_grab", { id: SoundNames.faf_fox_grabbed });
    sound.registerPlay("faf_fox_hehe", { id: SoundNames.faf_fox_hehehe });
    sound.registerPlay("faf_launch", { id: SoundNames.faf_fox_launched });
    sound.registerPlay("faf_intro_pull", { id: SoundNames.faf_fox_pulled });
    sound.registerPlay("faf_intro_spin", { id: SoundNames.faf_fox_spin });
    sound.registerPlay("faf_egg_twinkle", { id: SoundNames.faf_gemegg_twinkle });
    sound.registerPlay("faf_impact_ground_1", { id: SoundNames.faf_fox_impactground_1 });
    sound.registerPlay("faf_impact_ground_2", { id: SoundNames.faf_fox_impactground_2 });
    sound.registerPlay("faf_impact_ground_3", { id: SoundNames.faf_fox_impactground_3 });
    sound.registerPlay("faf_impact_ground_4", { id: SoundNames.faf_fox_impactground_4 });
    sound.registerPlay("faf_impact_ground_5", { id: SoundNames.faf_fox_impactground_5 });
    sound.registerPlay("faf_enter_space", { id: SoundNames.faf_fox_flying_getshelmet });
    sound.registerPlay("faf_hit_duck", { id: SoundNames.faf_fox_flying_impactduck });
    sound.registerPlay("faf_hit_pig", { id: SoundNames.faf_fox_flying_impactpig });

    sound.registerPlay("faf_tumble_1", { id: SoundNames.faf_fox_flying_spinning_v2a_loop, loop: true }); // fastest
    sound.registerStop("faf_tumble_1", [
        { id: SoundNames.faf_fox_flying_spinning_v2b_loop },
        { id: SoundNames.faf_fox_flying_spinning_v2c_loop },
        { id: SoundNames.faf_fox_flying_spinning_v2d_loop },
    ]);

    sound.registerPlay("faf_tumble_2", { id: SoundNames.faf_fox_flying_spinning_v2b_loop, loop: true });
    sound.registerStop("faf_tumble_2", [
        { id: SoundNames.faf_fox_flying_spinning_v2a_loop },
        { id: SoundNames.faf_fox_flying_spinning_v2c_loop },
        { id: SoundNames.faf_fox_flying_spinning_v2d_loop },
    ]);

    sound.registerPlay("faf_tumble_3", { id: SoundNames.faf_fox_flying_spinning_v2c_loop, loop: true });
    sound.registerStop("faf_tumble_3", [
        { id: SoundNames.faf_fox_flying_spinning_v2a_loop },
        { id: SoundNames.faf_fox_flying_spinning_v2b_loop },
        { id: SoundNames.faf_fox_flying_spinning_v2d_loop },
    ]);

    sound.registerPlay("faf_tumble_4", { id: SoundNames.faf_fox_flying_spinning_v2d_loop, loop: true }); // slowest
    sound.registerStop("faf_tumble_4", [
        { id: SoundNames.faf_fox_flying_spinning_v2a_loop },
        { id: SoundNames.faf_fox_flying_spinning_v2b_loop },
        { id: SoundNames.faf_fox_flying_spinning_v2c_loop },
    ]);

    sound.registerPlay("faf_stop_tumble", { id: SoundNames.faf_fox_dazed });
    sound.registerStop("faf_stop_tumble", [
        { id: SoundNames.faf_fox_flying_spinning_v2a_loop },
        { id: SoundNames.faf_fox_flying_spinning_v2b_loop },
        { id: SoundNames.faf_fox_flying_spinning_v2c_loop },
        { id: SoundNames.faf_fox_flying_spinning_v2d_loop },
    ]);

    // Bonus music
    sound.registerPlay("start_bonus_music", { id: SoundNames.fpg_bonus_bgTune, music: true, loop: true });
    sound.registerPlay("stop_bonus_music", { id: SoundNames.fpg_bonus_shortOutroTune, music: true });
    sound.registerStop("stop_bonus_music", { id: SoundNames.fpg_bonus_bgTune });

    // Slot
    sound.registerPlay("slot_reelspin", { id: SoundNames.reelspin });
    sound.registerPlay("slot_reelstop", { id: SoundNames.reelstop });
    sound.registerPlay("slot_fanfare", { id: SoundNames.fpg_fanfare });
    sound.registerPlay("slot_wilds_added_fox", { id: SoundNames.fpg_looney, volume: 0.7 });
    sound.registerPlay("slot_wilds_added_start", { id: SoundNames.fpm_sfx_DealMysterySymbolsLoop, loop: true });
    sound.registerStop("slot_wilds_added_end", { id: SoundNames.fpm_sfx_DealMysterySymbolsLoop });

    // Pick
    sound.registerPlay("lay_egg", [{ id: SoundNames.fpg_chickenLayEgg }, { id: SoundNames.faf_chickenegg_fall }]);
    sound.registerPlay("egg_land", { id: SoundNames.faf_chickenegg_impactfloor });
    sound.registerPlay("chickens_idle", { id: SoundNames.fpm_sfx_bonus_ChickenChatterLoop, loop: true });
    sound.registerStop("chicken_pick", { id: SoundNames.fpm_sfx_bonus_ChickenChatterLoop });
    sound.registerPlay("chicken_pick", [{ id: SoundNames.fpm_sfx_bonus_ChickenChatter }, { id: SoundNames.faf_chickenperched_selected }]);
    sound.registerPlay("pick_prize_reveal", { id: SoundNames.fpm_sfx_Kerching });
    sound.registerPlay("chicken_fly_away", { id: SoundNames.faf_chickenperched_flee });
}
